import Layout from "../../../components/layout/layout.js";
import Dashboard from "../../../components/dashboard/index.js";
import { useAuth } from "../../../Context/AuthContext";
import { CustomSpinner } from "../../../components/shared/Spinner";

function AdminIndexPage({ component, ...rest }) {
  const { userInfo, currentUser, loading } = useAuth();

  // Show loading spinner while authentication is being determined
  if (loading) {
    return <CustomSpinner />;
  }

  // If no user is authenticated, this shouldn't happen due to PrivateRoute
  if (!currentUser) {
    return <div>Please log in to access the dashboard.</div>;
  }

  return <Layout Component={Dashboard} controlsDisabled={true} {...rest} />;
}

export default AdminIndexPage;
